import { useCallback, useState } from 'react';

type Return = [boolean, (e: React.MouseEvent) => void, (e: React.MouseEvent) => void];

export const useCardHover = (): Return => {
  const [hover, setHover] = useState(false);

  const handleMouseEnter = useCallback((e: React.MouseEvent) => {
    if (e.nativeEvent.type !== 'mouseover') {
      setHover(true);
    }
  }, []);

  const handleMouseLeave = useCallback(() => {
    setHover(false);
  }, []);

  return [hover, handleMouseEnter, handleMouseLeave];
};
